import View from '@package/components/Blocks/Title/View';

export default View;
